import { render, staticRenderFns } from "./budgetEdit.vue?vue&type=template&id=87468ece&scoped=true&"
import script from "./budgetEdit.vue?vue&type=script&lang=js&"
export * from "./budgetEdit.vue?vue&type=script&lang=js&"
import style0 from "./budgetEdit.vue?vue&type=style&index=0&id=87468ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87468ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87468ece')) {
      api.createRecord('87468ece', component.options)
    } else {
      api.reload('87468ece', component.options)
    }
    module.hot.accept("./budgetEdit.vue?vue&type=template&id=87468ece&scoped=true&", function () {
      api.rerender('87468ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/budget/budgetEdit.vue"
export default component.exports